/**
 * Kitchvo collection page — grid/list toggle, mobile filter drawer,
 * URL-based sort + storefront filters (?sort_by=, ?filter.v.*).
 */
(function () {
  function debounce(fn, wait) {
    let timeout;
    return function debounced() {
      const args = arguments;
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function applyCollectionSearchParams(params) {
    params.delete('page');
    window.location.search = params.toString();
  }

  function applySortFromUrl(sortSelect) {
    const params = new URLSearchParams(window.location.search);
    params.set('sort_by', sortSelect.value);
    applyCollectionSearchParams(params);
  }

  function applyFiltersFromForm(form) {
    const params = new URLSearchParams(new FormData(form));

    // Drop empty price / unused fields so Shopify gets clean filter params.
    Array.from(params.keys()).forEach(function (key) {
      if (params.get(key) === '') params.delete(key);
    });

    const currentSort = new URLSearchParams(window.location.search).get('sort_by');
    if (currentSort) params.set('sort_by', currentSort);

    applyCollectionSearchParams(params);
  }

  function initSortSelect(root) {
    const sortSelect = root.querySelector('[data-kitchvo-sort]');
    if (!sortSelect || sortSelect.dataset.kitchvoSortInit === 'true') return;
    sortSelect.dataset.kitchvoSortInit = 'true';

    sortSelect.addEventListener('change', function () {
      applySortFromUrl(sortSelect);
    });
  }

  function initFiltersForm(root) {
    const form = root.querySelector('[data-kitchvo-filters-form]');
    if (!form || form.dataset.kitchvoFiltersInit === 'true') return;
    form.dataset.kitchvoFiltersInit = 'true';

    const applyDebounced = debounce(function () {
      applyFiltersFromForm(form);
    }, 500);

    form.addEventListener('change', function (event) {
      // Checkboxes (availability, etc.) should apply immediately.
      if (event.target && event.target.type === 'checkbox') {
        applyFiltersFromForm(form);
        return;
      }
      applyDebounced();
    });

    form.addEventListener('input', function (event) {
      // Price number fields fire input while typing — debounce the reload.
      if (event.target && event.target.type === 'number') {
        applyDebounced();
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFiltersFromForm(form);
    });
  }

  function initCollection(root) {
    if (!root || root.dataset.kitchvoInit === 'true') return;
    root.dataset.kitchvoInit = 'true';

    const grid = root.querySelector('.kitchvo-collection__grid');
    const viewButtons = root.querySelectorAll('[data-kitchvo-view]');
    const openBtn = root.querySelector('[data-kitchvo-open-filters]');
    const closeEls = root.querySelectorAll('[data-kitchvo-close-filters]');
    const backdrop = root.querySelector('.kitchvo-collection__drawer-backdrop');
    const defaultView = root.dataset.defaultView || 'grid';
    const storedView = sessionStorage.getItem('kitchvo-collection-view') || defaultView;

    function setView(view) {
      if (!grid) return;
      grid.setAttribute('data-view', view);
      viewButtons.forEach((btn) => {
        const active = btn.getAttribute('data-kitchvo-view') === view;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      grid.querySelectorAll('[data-list-item]').forEach((el) => {
        if (view === 'list') {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
      sessionStorage.setItem('kitchvo-collection-view', view);
    }

    function openFilters() {
      root.classList.add('is-filters-open');
      document.body.classList.add('kitchvo-filters-open');
      if (backdrop) backdrop.hidden = false;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }

    function closeFilters() {
      root.classList.remove('is-filters-open');
      document.body.classList.remove('kitchvo-filters-open');
      if (backdrop) backdrop.hidden = true;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    }

    viewButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        setView(btn.getAttribute('data-kitchvo-view'));
      });
    });

    if (openBtn) openBtn.addEventListener('click', openFilters);
    closeEls.forEach((el) => el.addEventListener('click', closeFilters));

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeFilters();
    });

    setView(storedView === 'list' ? 'list' : 'grid');
    initSortSelect(root);
    initFiltersForm(root);
  }

  function boot() {
    document.querySelectorAll('[data-kitchvo-collection]').forEach(initCollection);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
